export function listNames(names: string[]): string {
  if (names.length < 2) return names.join("")
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`
}

export const sameIds = (a: string[], b: string[]) =>
  a.length === b.length && a.every((id) => b.includes(id))
